import { cn } from '@e-kyc/utils';
import { cva, type VariantProps } from 'class-variance-authority';

const buttonVariants = cva('h-max cursor-pointer rounded-sm font-semibold', {
  variants: {
    variant: {
      default:
        'bg-primary text-text-primary hover:bg-primary-700 disabled:bg-gray-200 disabled:text-gray-400 disabled:pointer-events-none',
      outlined:
        'border border-text-disabled text-text-primary bg-transparent disabled:border disabled:border-text-disabled disabled:bg-transparent disabled:text-text-disabled disabled:pointer-events-none',
      text: 'text-primary hover:bg-gray-100 focus:text-primary-900 disabled:text-gray-300',
    },
    size: {
      sm: 'py-1.5 px-3 text-body2',
      md: 'py-2 px-3.5 text-body2',
      lg: 'py-2.5 px-4 text-body1',
    },
  },
  defaultVariants: {
    variant: 'default',
    size: 'lg',
  },
});

interface ButtonProps extends React.ComponentProps<'button'>, VariantProps<typeof buttonVariants> {
  children: React.ReactNode;
  className?: string;
  fullWidth?: boolean;
  loading?: boolean;
}

export default function Button({
  variant,
  size,
  children,
  className = '',
  fullWidth = false,
  onClick,
  disabled,
  loading,
  type = 'button',
  ...props
}: ButtonProps) {
  return (
    <button
      className={cn(buttonVariants({ variant, size }), fullWidth ? 'w-full' : 'w-max', className)}
      onClick={onClick}
      disabled={disabled || loading}
      type={type}
      {...props}
    >
      {loading ? (
        <div className='flex items-center justify-center'>
          <div className='border-primary mx-auto size-4 animate-spin rounded-full border-2 border-t-transparent'></div>
        </div>
      ) : (
        children
      )}
    </button>
  );
}
